const timerWorker = function () {
    self.addEventListener('message', (event: MessageEvent) => {
        const data = event.data;

        if (!data?.duration) {
            return;
        }

        let diff = data?.duration;

        const timer = setInterval(() => {
            if (diff > 0) {
                postMessage({ diff, isFinished: false });
                diff -= 1000;
            } else {
                postMessage({ diff, isFinished: true });
                clearInterval(timer);
            }
        }, 1000);

        postMessage('Message has been gotten!');
    });
};

const codeToString = timerWorker.toString();
const mainCode = codeToString.substring(codeToString.indexOf('{') + 1, codeToString.lastIndexOf('}'));
const blob = new Blob([mainCode], { type: 'application/javascript' });
export const timerWorkerScript = URL.createObjectURL(blob);